import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-basic',
  templateUrl: './basic.component.html',
  styleUrls: ['./basic.component.scss']
})
export class BasicComponent implements OnInit {

  obj;
  constructor(@Inject(MAT_DIALOG_DATA) data, private dialogRef: MatDialogRef<BasicComponent>) {
    this.obj = data;
   }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

}
